export default __webpack_public_path__ + "static/designer-bozidar-tanic-839b7062cd84e791ed8b4a4b910cb541.png";